import Header from '../../../Components/Header/Header';
import styles from './home.module.scss';
import { Helmet } from 'react-helmet-async';
import useInView from '../../../Components/UseInView/useInView';
import RevealImage from '../../../Components/RevealImage/revealImage';
import Button from '../../../Components/Button/Button';
// import propertyList from '../../../Data/PropertyList.json';
import serviceList from '../../../Data/Services.json';
// import PropertyCard from '../../../Components/PropertyCard/PropertyCard';
import ServiceDescriptionCard from '../../../Components/ServiceDescriptionCard/ServiceDescriprionCard';
import Cta from '../../../Components/Cta/Cta';
import Footer from '../../../Components/Footer/Footer';
import Faq from '../../../Components/Faq/Faq';
// import { useNavigate } from 'react-router-dom';

const Home = () => {
    // const navigate = useNavigate();
    const [landingRef, landingVisible] = useInView();
    const [sloganRef, sloganVisible] = useInView();
    const [aboutRef, aboutVisible] = useInView();
    // const [propertyListRef, propertyListVisible] = useInView();
    const [serviceListRef, serviceListVisible] = useInView();
    const [whyChooseUsRef, whyChooseUsVisible] = useInView();
    const [faqRef, faqVisible] = useInView();

    // let PropertyRender = propertyList.slice(0, 5).map((property) => {
    //     return (
    //         <PropertyCard
    //             key={property.id}
    //             id={property.id}
    //             rent={property.rent}
    //             address={property.address}
    //             city={property.city}
    //             province={property.province}
    //             bed={property.bed}
    //             bath={property.bath}
    //             sqft={property.sqft}
    //             onClick={() => navigate(`/property/${property.id}`)}
    //         />
    //     );
    // });

    let ServiceRender = serviceList.slice(0, 5).map((service) => {
        return (
            <ServiceDescriptionCard
                key={service.id}
                id={service.id}
                title={service.title}
                briefDescription={service.briefDescription}
                fullDescription={service.fullDescription}
                icon={service.path}
                image={service.image}
            />
        );
    });

    return (
        <>
            <Helmet>
                <title>Clear Property Management - Property Management Services</title>
                <meta name='description' content='We provide property management services.' />
                <link rel='canonical' href='/' />
            </Helmet>
            <Header />

            <div
                id='Landing'
                ref={landingRef}
                className={`${styles.landingContainer} ${landingVisible ? styles.visible : ''}`}
            >
                <img
                    src='https://images.unsplash.com/photo-1697686957280-2466e1e43ba7?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
                    alt='landing'
                />
                <h1
                    id='Slogan'
                    ref={sloganRef}
                    className={`${sloganVisible ? styles.visible : ''}`}
                >
                    CREATING BETTER
                    <br />
                    LIVING EXPERIENCES
                    <br />
                </h1>
            </div>

            <div
                id='About'
                ref={aboutRef}
                className={`${styles.aboutContainer} ${aboutVisible ? styles.visible : ''}`}
            >
                <div className={styles.aboutInnerContainer}>
                    <p>[About Us]</p>
                    <h1>Reliable. Responsive. Full-Service Property Care.</h1>
                    <p>
                        At Clear Property Management, we provide dependable, full-service solutions
                        for residential and commercial properties—serving communities from Waterloo
                        to Guelph. With a focus on transparency, responsive service, and long-term
                        value, we handle everything from tenant relations and maintenance to
                        financial reporting—so you can enjoy peace of mind while we take care of the
                        rest.
                    </p>
                    <Button buttonText='About Us' displayIcon={true} link='/about' />
                </div>
                <div className={styles.aboutInnerContainer}>
                    <RevealImage
                        src='https://images.unsplash.com/photo-1588835743485-5845e40364fe?q=80&w=2268&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
                        alt='landing'
                        imageStyle={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                        rollUpColor='#f6f6f6'
                    />
                </div>
            </div>

            {/* <div
                id='Our Properties'
                ref={propertyListRef}
                className={`${styles.propertyListContainer} ${propertyListVisible ? styles.visible : ''}`}
            >
                <p>[Our Properties]</p>
                <div className={styles.propertyListContainerHeader}>
                    <h1>Reliable Spaces. Exceptional Living.</h1>
                    <Button buttonText='View All' displayIcon={true} link='properties' />
                </div>
                <div className={styles.propertyListWrapper}>{PropertyRender}</div>
            </div> */}

            <div
                id='Our Services'
                ref={serviceListRef}
                className={`${styles.propertyListContainer} ${serviceListVisible ? styles.visible : ''}`}
            >
                <p>[Our Services]</p>
                <div className={styles.propertyListContainerHeader}>
                    <h1>Our Services</h1>
                    <Button buttonText='View All' displayIcon={true} link='services' />
                </div>
                <div className={styles.propertyListWrapper}>{ServiceRender}</div>
            </div>

            <div
                id='Why Choose Us'
                ref={whyChooseUsRef}
                className={`${styles.aboutContainer} ${whyChooseUsVisible ? styles.visible : ''}`}
            >
                <div className={styles.aboutInnerContainer}>
                    <p>[Why Choose Us]</p>
                    <h1>Built on Trust. Backed by Experience.</h1>
                    <p>
                        Choosing Clear Property Management means partnering with a team that values
                        transparency, responsiveness, and long-term care. We combine local
                        expertise, proven systems, and a commitment to protecting your investment—so
                        you can focus on what matters most.
                    </p>
                    <ul>
                        <h3>&#9657; Local Expertise</h3>
                        <p>
                            Based in Waterloo and serving Guelph and surrounding areas, we
                            understand the local rental market, bylaws, and what matters most to
                            both property owners and tenants.
                        </p>
                        <h3>&#9657; Full-Service Management</h3>
                        <p>
                            From tenant screening and rent collection to maintenance and
                            inspections, we handle everything so you don’t have to—professionally
                            and transparently.
                        </p>
                        <h3>&#9657; Responsive & Reliable</h3>
                        <p>
                            We prioritize communication, fast response times, and long-term
                            relationships. Your property is managed like it’s our own.
                        </p>
                    </ul>
                </div>
                <div className={styles.aboutInnerContainer}>
                    <RevealImage
                        src='https://cdn.prod.website-files.com/6787fd6e047993a568043b60/6787fd6e047993a568043bf9_details-image-01.jpg'
                        alt='landing'
                        imageStyle={{
                            width: '100%',
                        }}
                        rollUpColor='#f6f6f6'
                    />
                </div>
            </div>

            <div id='Cta' className={`${styles.aboutContainer} ${styles.visible}`}>
                <Cta />
            </div>

            <div
                id='Faq'
                ref={faqRef}
                className={`${styles.aboutContainer} ${faqVisible ? styles.visible : ''}`}
            >
                <div className={styles.aboutInnerContainer}>
                    <div className={styles.faqLeftBox}>
                        <div>
                            <p>[FAQ]</p>
                            <h1>Frequently Asked Questions</h1>
                        </div>
                        <div>
                            <h3>Still Have Questions?</h3>
                            <p>
                                Can’t find the answer you’re looking for? Please contact with our
                                customer service.
                            </p>
                            <Button buttonText='Contact Us' displayIcon={true} link='/contact' />
                        </div>
                    </div>
                </div>
                <div className={styles.aboutInnerContainer}>
                    <Faq
                        faqs={[
                            {
                                id: 1,
                                question: 'What services do you provide?',
                                answer: 'Our full-service management includes tenant placement, rent collection, maintenance coordination, property inspections, legal compliance, and detailed financial reporting.',
                            },
                            {
                                id: 2,
                                question: 'How do you screen potential tenants?',
                                answer: 'We conduct a thorough screening process including credit checks, income verification, employment history, reference checks, and a review of previous rental behavior.',
                            },
                            {
                                id: 3,
                                question: 'How are maintenance requests handled?',
                                answer: 'Tenants can submit maintenance requests online or by phone. We respond promptly, dispatch trusted contractors, and keep you informed throughout the process.',
                            },
                            {
                                id: 4,
                                question: 'How and when do property owners get paid?',
                                answer: 'We collect rent at the start of each month and disburse payments to property owners typically within the first 7 business days, along with a detailed statement.',
                            },
                            {
                                id: 5,
                                question: 'What areas do you currently serve?',
                                answer: 'We proudly serve Waterloo, Kitchener, Guelph, Cambridge, and surrounding areas in Southern Ontario.',
                            },
                        ]}
                    />
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Home;
